import styled from "@emotion/styled";
import Switch, { switchClasses } from "@mui/material/Switch";
import theme from "common/theme/theme";

export const OnOffToggle = styled(Switch)({
    width: 52,
    height: 18,
    padding: 0,
    [`& .${switchClasses.switchBase}`]: {
      padding: 3,
      color: "#ff6a00",
    },
    [`& .${switchClasses.thumb}`]: {
      width: 13,
      height: 13,
      backgroundColor: theme.palette.primary.main,
    },
    [`& .${switchClasses.track}`]: {
      backgroundColor: theme.palette.grey[300],
      opacity: "1 !important",
      borderRadius: 20,
      position: "relative",
      "&:before, &:after": {
        display: "inline-block",
        position: "absolute",
        top: "50%",
        width: "50%",
        transform: "translateY(-50%)",
        color: "#fff",
        textAlign: "center",
        fontSize: "11px",
        fontWeight: 500,
      },
      "&:before": {
        opacity: 1,
      },
      "&:after": {
        content: '"OFF"',
        right: 4,
      },
    },
    [`& .${switchClasses.checked}`]: {
      [`&.${switchClasses.switchBase}`]: {
        color: "#185a9d",
        transform: "translateX(32px)",
        "&:hover": {
          backgroundColor: "rgba(24,90,257,0.08)",
        },
      },
      [`& .${switchClasses.thumb}`]: {
        backgroundColor: theme.palette.primary.main,
      },
      [`& + .${switchClasses.track}`]: {
        background: "white !important",
        "&:before": {
          content: '"ON"',
          left: 4,
          color: "black",
          opacity: 1,
        },
        "&:after": {
          opacity: 0,
        },
      },
    },
  });
  
  